// en.js
export default {
    route: {
        dashboard: 'Dashboard'
    },
    loginPage: {
        title: 'Website Management System',
        username: 'Username',
        password: 'Password',
        captcha: "Verificode",
        usernameRule: 'Please enter the username',
        passwordRule: 'Please enter the password',
        captchaRule: "Please enter the verificode",
        captchaError: "Verification code error",
        loginSuccess: "Login successful",
        loginFailed: "Login failed",
        login: 'Login',
        switchLangSuccess: 'switch language success'
    },
    layout: {
        header: {
            logo: {
                en: "XIATECH",
                zh: "夏溪科技"
            },
            nav: {
                products: 'Products',
                solutions: 'Solutions',
                services: 'Services',
                about: 'About Us',
                contact: 'Contact Us'
            },
            search: {
                placeholder_search: 'Search···',
                btn_advancedSearch: 'Advance Search',
                btn_search: 'Search',
            }
        }
    }
};